import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterState } from "../../interface";

export const initialState: FilterState = {
  selectedFilter: {
    dateRange: "",
    dateRangeText: "",
    startDate: "",
    endDate: "",
    selectedRegions: [],
    selectedCountries: [],
    selectedAffiliates: [],
    selectedEvaluation: [],
    selectedRisk: [],
    selectedStatus: [],
    selectedProduct: [],
    selectedSampleId: [],
    selectedFieldName: [],
  },
  refData: {},
  openSideBar: false,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilterResult(state, action: PayloadAction<any>) {
      state.selectedFilter = { ...state.selectedFilter, ...action.payload };
    },
    resetFilterResult(state) {
      const { reviewType, dateRange, dateRangeText, startDate, endDate } =
        state.selectedFilter;
      state.selectedFilter = {
        ...initialState.selectedFilter,
        reviewType,
        dateRange,
        dateRangeText,
        startDate,
        endDate,
      };
    },
    setRefData(state, action: PayloadAction<any>) {
      state.refData = action.payload;
    },
    setToggleSideBar(state, action: PayloadAction<boolean>) {
      state.openSideBar = action.payload;
    },
    resetState(state) {
      state = Object.assign(initialState);
      return state;
    },
  },
});

export const {
  setFilterResult,
  resetFilterResult,
  setRefData,
  setToggleSideBar,
  resetState,
} = filterSlice.actions;

export default filterSlice.reducer;
